import React from 'react';
import PropTypes from 'prop-types';
import { List } from 'immutable';

import GroupItem from '../GroupItem';

export default function GroupsList (props) {
  const { groupsIds } = props;

  return groupsIds
    .map((groupId) => {
      return (
        <GroupItem key={groupId} groupId={groupId} />
      );
    });
}

GroupsList.propTypes = {
  groupsIds: PropTypes.instanceOf(List).isRequired,
};
